export const GEOMETRY_SCALE = {
    rootRadius: 6,
    multipliers: {
        resourceTypes: {
            ringRadiusFromRoot: 20 / 6,
            sphereRadiusFromRing: 1 / 20,
        },
        roles: {
            ringRadiusFromResourceTypeSphere: 2.4 / 1,
            sphereRadiusFromRing: 0.35 / 2.4,
        },
        toolSteps: {
            ringGapFromResourceTypeRing: 0.9,
            tubeRadiusFromRoot: 0.06 / 6,
        },
    },
    workflowStateEntries: {
        panels: {
            panelWidthFromRoot: 3.6 / 6,
            panelHeightFromRoot: 1.8 / 6,
            panelDepthFromRoot: 0.06 / 6,
        },
        wheels: {
            bandGeometry: 1,
        },
    },
} as const;
